import DemoNavbar from "components/Navbars/DemoNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import { routes } from "../../routes/routes";
import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import Prospeccion from "./components/Prospeccion";
import Construccion from "./components/Construccion";
import Instalaciones from "./components/Instalaciones";
import imagenPrincipal from "../../assets/avantSolar/Promociones/promociones-1.jpg";
import imagenPrincipal2 from "../../assets/avantSolar/Promociones/promociones-2.jpg";
import imagenPrincipal3 from "../../assets/avantSolar/Promociones/promociones-3-expo.jpg";
import imagenPrincipal4 from "../../assets/avantSolar/Promociones/Huertas/promociones-4-albox.jpg";
import HuertosSolares from "./components/HuertosSolares";
import Footer from "components/Footer/Footer";
import { Helmet } from "react-helmet-async";

function Promociones(props) {
  const [component, setComponent] = useState(Prospeccion);
  const [imagen, setImagen] = useState(imagenPrincipal);
  const [nombreComponente, setNombreComponente] = useState(Prospeccion.name);

  const setElementos = (componente, name) => {
    setComponent(componente);
    setNombreComponente(name);
    console.log(componente.name);
  };

  return (
    <>
      <Helmet>
        <title>Promociones</title>
        <meta
          name="description"
          content="Buscamos tejados o cubiertas de grandes dimensiones en régimen de
        alquiler para realizar instalaciones solares fijas."
        />
        <meta name="robots" content="all" />
      </Helmet>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel h-100">
          <div>
            <DemoNavbar {...props} hideTitle />

            <Row>
              <Col xs={12} sm={6} md={5} xl={5} className="fondoColumna  p-0">
                <div className="linea1 helpHeaderLine">
                  <Row>
                    <Col xs={1}>
                      <div className="linea2 h-100 p-3"></div>
                    </Col>
                    <Col>
                      <div className="d-flex justify-content-center flex-column align-items-center p-2">
                        <p className="p-0 m-0 h4 font-weight-bold">
                          PROMOCIONES
                        </p>
                        <p className="p-0 m-0 text-light h6">
                          MONTAJE Y EXPLOTACIÓN DE INSTALACIONES
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="p-5">
                  <p className="mb-3">
                    Nuestros proyectos se adaptan a las necesidades de cada
                    cliente.
                  </p>
                  <ul className="seguidoresList">
                    <li
                      onClick={() => {
                        setElementos(Prospeccion, "Prospeccion");
                        setImagen(imagenPrincipal);
                      }}
                      className={`${
                        nombreComponente == "Prospeccion"
                          ? "selectedSeguidores"
                          : ""
                      } p-1`}
                    >
                      {"> "}En prospección
                    </li>

                    <li
                      onClick={() => {
                        setElementos(Construccion, "Construccion");
                        setImagen(imagenPrincipal2);
                      }}
                      className={`${
                        nombreComponente == "Construccion"
                          ? "selectedSeguidores"
                          : ""
                      } p-1`}
                    >
                      {"> "}En construcción
                    </li>

                    <li
                      onClick={() => {
                        setElementos(
                          <Instalaciones setImagen={setImagen} />,
                          "Instalaciones"
                        );
                        setImagen(imagenPrincipal3);
                      }}
                      className={`${
                        nombreComponente == "Instalaciones"
                          ? "selectedSeguidores"
                          : ""
                      } p-1`}
                    >
                      {"> "}Instalaciones realizadas
                    </li>

                    <li
                      onClick={() => {
                        setElementos(
                          <HuertosSolares setImagen={setImagen} />,
                          "HuertosSolares"
                        );
                        setImagen(imagenPrincipal4);
                      }}
                      className={`${
                        nombreComponente == "HuertosSolares"
                          ? "selectedSeguidores"
                          : ""
                      } p-1`}
                    >
                      {"> "}Nuestros huertos solares
                    </li>
                  </ul>
                  <p className="text-start mt-3">
                    No dude en consultarnos para más información.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={7} xl={7} className="p-0">
                <div className="linea1 helpHeaderLine d-none d-sm-block"></div>
                <div className="p-4">{component}</div>
              </Col>
            </Row>
            <div>
              <img className="imagenPromociones " src={imagen}></img>
            </div>
          </div>
          <Footer mt={0} />
        </div>
      </div>
    </>
  );
}

export default Promociones;
